import React, { useRef } from "react";
import "./Contact.css";
// import Hello from "../../img/vg.png";
import { ImPhone } from "react-icons/im";
import { MdEmail } from "react-icons/md";
import { RiWhatsappFill } from "react-icons/ri";
import { motion } from "framer-motion";
import emailjs from "emailjs-com";
import toast from "react-hot-toast";

const Contact = () => {
  const [result, setResult] = React.useState("");
  const variants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  

  };
  const onSubmit = async (event) => {
    event.preventDefault();
    setResult("Sending....");
    const formData = new FormData(event.target);

    formData.append("access_key", "06e7aa30-a21b-4ebb-9a06-81cfd9ccbf32");

    const response = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      body: formData
    });

    const data = await response.json();

    if (data.success) {
      setResult("Form Submitted Successfully");
      event.target.reset();
    } else {
      console.log("Error", data);
      setResult(data.message);
    }
  };

  const item = {
    hidden: {
      opacity: 0,
      x: -50,
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.8,
      },
    },
  };

  const transition = { duration: 2, type: "spring" };
  const form = useRef();

  function sendEmail(e) {
    e.preventDefault();
    emailjs
      .sendForm("gmail", "template_9qerv09", form.current, "qAQs4ppDy8bcR0Dn5")
      .then(
        (result) => {
          e.target.reset();
          toast.success("Message Sent");
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
          toast.error("Error");
        }
      );
  }
    
  //  <motion.input  initial={{ opacity: 0, scale: 0.5 }}
  //       whileInView={{ opacity: 1, scale: 1 }}
  //       transition={{
  //         duration: 0.8,
  //         delay: 0.1,
  //         ease: [0, 0.71, 0.2, 1.01]}}
  //               type="text"
  //               name="user_name"
  //               className="user"
  //               placeholder="Name"
  //               required
  //             />
  return (
    <div className="contact-form" id="contact">
      <div className="c-contactt">
        <span>Contact me</span>
        <span>
          Let's talk about your website or project. Send a message and get in
          touch with me.
        </span>
      </div>

      <div className="c-form">
         <div className="c-right">
      <form onSubmit={onSubmit}>
        <input type="text" name="name" className="user"  placeholder="Name"required/>
        <input type="email" name="email" className="user" placeholder="Email" required/>
        <input type="text" name="subject " placeholder="subject " className="user" required/>

        <textarea name="message" className="user" placeholder="Enter Message" required></textarea>

        <button type="submit" className="a-btn">Submit</button>

      </form>
      <span>{result}</span>

    </div>
       {/* <div className="c-right">
          <motion.form
            ref={form}
            onSubmit={sendEmail}
            variants={variants}
            initial="hidden"
            whileInView="show"
          >
            <motion.input
              variants={item}
              type="text"
              name="user_name"
              className="user"
              placeholder="Name"
              required
            />
            <motion.input
              variants={item}
              type="email"
              name="user_email"
              className="user"
              placeholder="Email"
              required
            />
            <motion.textarea
              variants={item}
              name="message"
              className="user"
              placeholder="Your Message"
              required
            />
            <motion.input
              variants={item}
              type="submit"
              value="Send Message"
              className="a-btn"
            />
          </motion.form>
        </div>
*/}
        <div className="c-left">
          <span>My Phone</span>
          <div className="c-phone">
            <ImPhone className="c-icon" />
            <a href="tel:+916378867951">+916378867951</a>

            <motion.a
              title="Feel free to contact me on Whatsapp"
              className="whatsapp"
              target="blank"
              // href="https://wa.me/"
              href="https://api.whatsapp.com/send?phone=+916378867951&text=Hi, I contacted you through your website."
              initial={{ opacity: 0, scale: 0.5 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{
                duration: 0.8,
                delay: 0.3,
                ease: [0, 0.71, 0.2, 1.01],
              }}
            >
              <RiWhatsappFill />
            </motion.a>
          </div>

          <span>Email Address</span>
          <div className="c-phone">
            <MdEmail className="c-icon" />
            <a href="mailto:arvindkumarsikandra2002@gmail.com">
            arvindkumarsikandra2002@gmail.com
            </a>
          </div>
          <motion.img
            alt="HELLO"
            title="🤝"
            src="https://res.cloudinary.com/dsr70k3to/image/upload/v1687765749/Portfolio/Hello-img_pjzksy.webp"
            initial={{ opacity: 0 }}
            whileInView={{ x: [100, 0, 0], opacity: 1 }}
            transition={transition}
          />
        </div>
      </div>
    </div>
  );
};

export default Contact;
